import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-flip-vertical-icon',
  templateUrl: './design-flip-vertical.component.html'
})
export class DesignFlipVerticalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
